const OpportunityTypes = {
    TREASURY_BILL: 'TreasuryBill',
    SOVEREIGN_GOLD_BONDS: 'SovereignGoldBond',
    G_SEC: 'GSec',
    SDL: 'SDL',
    SECURITISED_DEBT_INSTRUMENT: 'SecuritisedDebtInstrument',
    // Todo -  check impact of USDI
    UNLISTED_SECURITISED_DEBT_INSTRUMENT: 'UnlistedSecuritisedDebtInstrument',
    CORPORATE_BOND: 'CorporateBond'
};

Object.freeze(OpportunityTypes);

module.exports = OpportunityTypes;
